import cx from 'classnames'
import { useCallback, useMemo, useState } from 'react'

import Item, { type ItemProps } from './item'

type ItemWithId = ItemProps & {
  id: string
}

export interface ItemListProps {
  items: ItemWithId[]
  defaultValue?: string
  onChange?: (id: string) => void
  className?: string
}

const ItemList = ({
  items,
  defaultValue,
  onChange,
  className,
}: ItemListProps) => {
  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue)

  const handleClick = useCallback(
    (item: ItemWithId) => {
      // Ignore disabled items and selected item
      if (item.disabled || item.id === selectedId) {
        return
      }

      setSelectedId(item.id)

      if (onChange) {
        onChange(item.id)
      }
    },
    [onChange, selectedId],
  )

  const sortedItems = useMemo(
    () =>
      items.sort((item1, item2) =>
        !item1.disabled && item2.disabled
          ? -1
          : item1.disabled && !item2.disabled
            ? 1
            : 0,
      ),
    [items],
  )

  return (
    <div className={cx('flex flex-col w-full space-y-2.5', className)}>
      {sortedItems.map((item) => (
        <Item
          key={`${item.id}`}
          selected={item.id === selectedId}
          onClick={() => handleClick(item)}
          image={item.image}
          title={item.title}
          subtitle={item.subtitle}
          description={item.description}
          details={item.details}
          disabled={item.disabled}
          error={item.error}
          className={item.className}
        />
      ))}
    </div>
  )
}

export default ItemList
